export const SET_USER_DETAILS = "set_user_details";
export const setUserDetails = (response = {}) => {
  return (dispatch) => {
    dispatch({
      type: SET_USER_DETAILS,
      payload: response,
    });
  };
};
